// Same published catalog used by JAB's invoice reference data. Only descriptive
// metadata is used here; catalog prices never replace saved invoice values.
const CATALOG_URL = "https://public-assets.ambifi.com/projects/jab/priceSheets/priceSheet.json";
let pendingCatalog;

export function indexTaskCatalog(records = []) {
	const index = Object.create(null);
	if (!Array.isArray(records)) return index;
	records.forEach(record => {
		if (!record || typeof record.id !== "string" || !record.id.trim()) return;
		// An ambiguous ID cannot establish whether work is applicable.
		index[record.id] = Object.prototype.hasOwnProperty.call(index, record.id) ? null : record;
	});
	return index;
}

export function loadJabTaskCatalog() {
	if (!pendingCatalog) {
		pendingCatalog = Promise.resolve().then(() => fetch(CATALOG_URL))
			.then(response => {
				if (!response.ok) throw new Error("Task catalog unavailable");
				return response.json();
			})
			.then(data => {
				if (!Array.isArray(data.priceSheet)) throw new Error("Invalid task catalog");
				return indexTaskCatalog(data.priceSheet);
			})
			.catch(() => {
				// Keep unknown rows as tasks and allow a later view to retry.
				pendingCatalog = null;
				return null;
			});
	}
	return pendingCatalog;
}
